<template>
  <card class="mortgage-alternative-card padding-vertical-ml">
    <div class="flex-row">
      <div class="flex-column">
          <div class="ri-body">{{title}}</div>
          <div class="margin-top-s saving-amount">
            <span>{{savingContent}}</span><span class="diff-number ri-font-weight-bold">{{savingAmount}} ₪</span>
          </div>
      </div>
      <div class="image-container">
        <img :src="imgSrc" class="alternative-image" />
      </div>
    </div>
    <basic-label class="margin-top-m label" :background-color="labelBackgroundColor">
      {{labelText}}
    </basic-label>
    <riseup-button class="margin-top-ml" title="ספרו לי עוד" color="dark-green" variant="secondary"
    @click="handelTellMeMoreClick"/>
  </card>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import BasicLabel from '@/base-components/BasicLabel.vue';

export default {
  name: 'MortgageAlternativeCard',
  components: {
    Card: BaseUI.Card,
    RiseupButton: BaseUI.RiseupButton,
    BasicLabel,
  },
  props: {
    title: { type: String },
    imgSrc: { type: String },
    savingAmount: { type: String },
    savingContent: { type: String },
    labelText: { type: String },
  },
  computed: {
    labelBackgroundColor() {
      return BaseUI.Colors.riseupLightGreen;
    },
  },
  methods: {
    handelTellMeMoreClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
.mortgage-alternative-card {
  background: $riseup_white;
  color: $riseup_black;
}

.diff-number{
  color: $riseup_green;
}

.label {
  text-align: center;
}

.saving-amount {
  font-size: 28px;
  line-height: 32px;
}

.image-container {
  display: flex;
  align-items: flex-end;
}

.alternative-image {
  max-width: 100px;
}

</style>
